<template>
  <div>
    <label :for="`input_${_uid}`">
      <form-field
        full-width
        :required="required"
        :type="type"
        :label="label"
        :id="`input_${_uid}`"
        :name="`input_${_uid}`"
        :helper-text="helper_text"
        :show-counter="maxlengthVal !== null"
        :max-length="maxlengthVal"
        v-model="localVal"
        :placeholder="placeholder"
        @input="handleKeyUp"
        :pattern="regexPattern"
      ></form-field>
    </label>

    <p v-if="error" class="validation-error">{{error}}</p>
  </div>
</template>

<script>
export default {
  props: {
    label: {
      type: String
    },
    value: {
      type: String
    },
    placeholder: {
      type: String,
      default: "Enter a value here"
    },
    required: {
      type: [Boolean, String],
      default: false
    },
    error: {
      type: [String, Object, Boolean]
    },
    helper_text: {
      type: String
    },
    type: {
      type: String,
      default: "text"
    },
    minlength: {
      type: String,
      default: "0"
    },
    maxlength: {
      type: String,
      default: null
    }
  },
  methods: {
    handleKeyUp(val) {
      this.$emit("input", val);
    }
  },
  computed: {
    compVal: {
      get() {
        return this.value;
      },
      set(newVal, oldVal) {
        this.$emit("updated", newVal);
      }
    },
    maxlengthVal() {
      return parseInt(this.maxlength);
    },
    regexPattern() {
      if (this.type === "tel") {
        return "[0-9]{4,5}[' ']?[0-9]{3,6}[' ']?[0-9]{3,4}?";
      }
      return null;
    }
  },
  data() {
    return {
      id: null,
      localVal: ""
    };
  },
  mounted() {
    this.id = this._uid;

    if (this.value) {
      this.localVal = this.value;
    }
  }
};
</script>

<style scoped lang='scss'>
label {
  font-size: 1.25rem;
  line-height: 1.2;
  padding-bottom: 0.5rem;
}

.reqstar {
  color: red;
}
input {
  padding: 10px;
  width: 100%;
  background: white;
  @media (min-width: 768px) {
    max-width: 50vw;
  }
}
</style>